import type { PageProps } from './Page.types';
import { PageContext } from './PageContext';

export const Page = ({ modals, children, notifications }: PageProps) => {
  const contextValue: PageContext = {
    notifications,
  };

  return (
    <PageContext.Provider value={contextValue}>
      {children}
      {modals}
    </PageContext.Provider>
  );
};
